import { call, put, takeLatest } from "redux-saga/effects";

import {
  createSectionFailure,
  createSectionStart,
  createSectionSuccess,
} from "../reducer";
import { postSection } from "../../../services/section";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { successNotifier } from "../../../utils/helpers";

export function* createSection({ payload }) {
  const { data, callback } = payload;

  const response = yield call(postSection, data);
  const { success, raw, message, statusCode } = response;

  if (success) {
    yield put(createSectionSuccess());
    successNotifier("Section created successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(createSectionFailure(message || raw));
    networkErrorHandler(statusCode, message || raw);
  }
}

export default function* onCreateSection() {
  yield takeLatest(createSectionStart, createSection);
}
